import React, { useEffect, useState, useContext } from 'react';
import styled from '@emotion/styled';
import { ThemeContext } from '../../../context';
import { calculateTimeLeft, getCountdownString } from './helpers';

const DateCountdown = ({ startDate }: { startDate: string }): JSX.Element | null => {
  const {
    components: { globalBodyFontStyle },
  } = useContext(ThemeContext);

  const [timeLeft, setTimeLeft] = useState<{ [key: string]: number }>(calculateTimeLeft(startDate));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(startDate));
    }, 1000);
    return () => clearTimeout(timer);
  });

  if (!startDate) return null;

  const CountdownMessage = styled.div`
    ${globalBodyFontStyle}
    margin-top: 40px;
    // TODO: TEXT-ALIGNMENT
    text-align: center;
  `;

  const countdownString = getCountdownString(timeLeft);

  if (!countdownString) return null;

  return <CountdownMessage>{countdownString}</CountdownMessage>;
};

export default DateCountdown;
